<template>
    <div class="panel panel-default">
        <div class="inspection-tab-white" id="test-drive-container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="test-drive-title">Комментарий к тест драйву</div>
                    <div class="test-drive-comment" v-if="inspection_test_drive">{{ inspection_test_drive.comment }}</div>
                    <table class="table table-striped striped-table-inspection" id="test-drive-table">
                        <thead>
                        <tr>
                            <th colspan="3"></th>
                        </tr>
                        </thead>
                        <tbody v-if="inspection_test_drive">

                        <tr v-if="inspection_test_drive.noise_engine != null">
                            <td>Посторонний шум в моторном отсеке</td>
                            <td>{{ (inspection_test_drive.noise_engine) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.noise_engine_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.noise_engine_comment != null">{{ inspection_test_drive.noise_engine_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.work_kpp != null">
                            <td>Работа КПП</td>
                            <td>{{ (inspection_test_drive.work_kpp) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.work_kpp_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.work_kpp_comment != null">{{ inspection_test_drive.work_kpp_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.work_navigation_video != null">
                            <td>Работа навигации и камер</td>
                            <td>{{ (inspection_test_drive.work_navigation_video) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.work_navigation_video_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.work_navigation_video_comment != null">{{ inspection_test_drive.work_navigation_video_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.power_steering != null">
                            <td>Работа усилителя руля</td>
                            <td>{{ (inspection_test_drive.power_steering) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.power_steering_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.power_steering_comment != null">{{ inspection_test_drive.power_steering_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.leaving_aside != null">
                            <td>Уход в сторону от прямолинейного движения</td>
                            <td>{{ (inspection_test_drive.leaving_aside) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.leaving_aside_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.leaving_aside_comment != null">{{ inspection_test_drive.leaving_aside_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.leaving_aside_braking != null">
                            <td>Уход в сторону при торможение</td>
                            <td>{{ (inspection_test_drive.leaving_aside_braking) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.leaving_aside_braking_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.leaving_aside_braking_comment != null">{{ inspection_test_drive.leaving_aside_braking_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.beating_brake_disc != null">
                            <td>Биение тормозных дисков</td>
                            <td>{{ (inspection_test_drive.beating_brake_disc) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.beating_brake_disc_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.beating_brake_disc_comment != null">{{ inspection_test_drive.beating_brake_disc_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.noises_when_driving != null">
                            <td>Стуки и посторонние шумы при движение</td>
                            <td>{{ (inspection_test_drive.noises_when_driving) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.noises_when_driving_comment }}
                                </div>
                                <div class="custom_tooltip"
                                     v-if="inspection_test_drive.noises_when_driving_comment != null">{{ inspection_test_drive.noises_when_driving_comment }}</div>
                            </td>
                        </tr>
                        <tr v-if="inspection_test_drive.work_clutch != null">
                            <td>Работа сцепления</td>
                            <td>{{ (inspection_test_drive.work_clutch) ? '«Всё ok»' : '«Есть проблема»' }}</td>
                            <td>
                                <div class="description_test">
                                    {{ inspection_test_drive.work_clutch_comment }}
                                </div>
                                <div class="custom_tooltip" v-if="inspection_test_drive.work_clutch_comment != null">{{ inspection_test_drive.work_clutch_comment }}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'
    export default {
        name: 'InspectionTestDrive',
        props: ['inspection_id'],
        asyncComputed: {
            inspection_test_drive() {
                return axios
                .get('/api/inspections/' + this.inspection_id + '/test-drive', {
                    params: {}
                })
                .then(({data}) => {
                    return data
                })
            },
        },
        methods: {}

    }
</script>



// WEBPACK FOOTER //
// InspectionTestDrive.vue?7bc8e34b